<template>
  <div class="rounded-2xl shadow-xl bg-white overflow-hidden border border-orange-100">
    <div class="px-7 pt-7 pb-5">
      <div class="flex items-center gap-3">
        <img :src="logoUrl" alt="Respina" class="h-8 w-auto" />
        <div>
          <h1 class="text-xl font-extrabold text-gray-900 leading-tight">Create account</h1>
          <p class="text-sm text-gray-500">Get started</p>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit" class="px-7 pb-7">
      <div
        v-if="error"
        class="mb-4 p-3 rounded-xl bg-red-50 border border-red-100 text-red-700 text-sm"
      >
        {{ error }}
      </div>

      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-semibold mb-2">Name (optional)</label>
        <div class="relative">
          <i class="fas fa-user absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input
            v-model="name"
            type="text"
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="Your name"
          />
        </div>
      </div>

      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-semibold mb-2">Email</label>
        <div class="relative">
          <i class="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input
            v-model="email"
            type="email"
            required
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="you@example.com"
          />
        </div>
      </div>

      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-semibold mb-2">Password (min 6 chars)</label>
        <div class="relative">
          <i class="fas fa-lock absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input
            v-model="password"
            type="password"
            required
            minlength="6"
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="••••••••"
          />
        </div>
      </div>

      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-semibold mb-2">Confirm password</label>
        <div class="relative">
          <i class="fas fa-check absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input
            v-model="passwordConfirm"
            type="password"
            required
            class="w-full h-12 pl-11 pr-4 border-2 border-gray-200 rounded-xl focus:border-respina-primary focus:ring-2 focus:ring-orange-100 outline-none"
            placeholder="••••••••"
          />
        </div>
      </div>

      <button
        type="submit"
        class="w-full h-12 bg-respina-primary hover:bg-respina-secondary text-white font-bold rounded-xl transition-all shadow-md hover:shadow-lg disabled:opacity-50"
        :disabled="loading"
      >
        {{ loading ? "Creating..." : "Create account" }}
      </button>

      <p class="mt-4 text-center text-gray-600 text-sm">
        Already have an account?
        <router-link to="/auth/login" class="text-respina-primary font-bold">Sign in</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import { register } from "@/lib/auth";
import logoUrl from "@/assets/respina/logo.png";

export default {
  data() {
    return { name: "", email: "", password: "", passwordConfirm: "", error: null, loading: false, logoUrl };
  },
  methods: {
    async submit() {
      this.error = null;
      if (this.password !== this.passwordConfirm) {
        this.error = "Passwords do not match.";
        return;
      }
      if (this.password.length < 6) {
        this.error = "Password must be at least 6 characters.";
        return;
      }
      this.loading = true;
      try {
        await register(this.email, this.password, this.name);
        this.$router.replace("/airport-board");
      } catch (e) {
        this.error = e?.message || "Registration failed";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
